var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _g, _rect100, _rect101, _rect102, _path, _g2, _rect103, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatchAmlImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 247,
    viewBox: "0 0 405 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 249.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 341.5,
    y: 38.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 249.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 341.5,
    y: 61.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 249.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 341.5,
    y: 84.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 249.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 341.5,
    y: 107.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 249.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 341.5,
    y: 130.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 249.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 341.5,
    y: 153.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 249.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 341.5,
    y: 176.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 171,
    transform: "translate(39 35)",
    fill: "url(#paint0_radial_5336_59870)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5336_59870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 26C63 19.9249 67.9249 15 74 15H282.585C286.116 15 289.534 16.2457 292.237 18.5179L318.614 40.691L340.229 60.4074C343.345 63.2496 345.12 67.2721 345.12 71.4895V314.438H63V26Z",
    fill: "#D9E5F8",
    stroke: "#3F7CDB",
    strokeWidth: 2
  }))), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 269,
    transform: "translate(39 14)",
    fill: "url(#paint1_linear_5336_59870)"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 87.5,
    width: 305,
    height: 55,
    rx: 9.5,
    fill: "white"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 87.5,
    width: 305,
    height: 55,
    rx: 9.5,
    stroke: "#3F7CDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 115.5H126.5",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5336_59870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 76,
    width: 306,
    height: 56,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 110,
    width: 112,
    height: 6,
    rx: 3,
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 92,
    width: 145,
    height: 12,
    rx: 6,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6586 90H68.75C67.7835 90 67 90.7835 67 91.75V116.25C67 117.216 67.7835 118 68.75 118H86.25C87.2165 118 88 117.216 88 116.25V97.1782L79.6584 97.1784L79.6586 90Z",
    fill: "#F3F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 96.2954V96.3032L80.5335 96.3034L80.5336 90H80.5448L88 96.2954Z",
    fill: "#F3F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8026 106.313C80.7569 106.359 80.7026 106.395 80.6427 106.42C80.5829 106.445 80.5188 106.457 80.454 106.457C80.3892 106.457 80.3251 106.445 80.2652 106.42C80.2054 106.395 80.1511 106.359 80.1053 106.313L77.9935 104.201V110.23C77.9935 110.361 77.9416 110.486 77.8493 110.578C77.757 110.67 77.6318 110.722 77.5013 110.722C77.3707 110.722 77.2455 110.67 77.1532 110.578C77.0609 110.486 77.0091 110.361 77.0091 110.23V104.201L74.8964 106.313C74.8039 106.405 74.6785 106.457 74.5477 106.457C74.417 106.457 74.2916 106.405 74.1991 106.313C74.1066 106.22 74.0547 106.095 74.0547 105.964C74.0547 105.833 74.1066 105.708 74.1991 105.615L77.1522 102.662C77.1979 102.616 77.2523 102.58 77.3121 102.555C77.3719 102.53 77.4361 102.518 77.5009 102.518C77.5656 102.518 77.6298 102.53 77.6896 102.555C77.7494 102.58 77.8038 102.616 77.8495 102.662L80.8026 105.615C80.8485 105.661 80.8849 105.716 80.9097 105.775C80.9346 105.835 80.9474 105.899 80.9474 105.964C80.9474 106.029 80.9346 106.093 80.9097 106.153C80.8849 106.213 80.8485 106.267 80.8026 106.313Z",
    fill: "#C7CBD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 104.5H126.5",
    stroke: "#D9E5F8",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5336_59870)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5336_59870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 85,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#5F92E1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.003,
    cy: 103.001,
    rx: 6.66667,
    ry: 6.66667,
    fill: "url(#paint2_linear_5336_59870)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.331 122.166C166.331 126.308 166.331 129.666 152.997 129.666C139.664 129.666 139.664 126.308 139.664 122.166C139.664 118.024 145.634 114.666 152.997 114.666C160.361 114.666 166.331 118.024 166.331 122.166Z",
    fill: "url(#paint3_linear_5336_59870)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 85,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    strokeWidth: 2
  })))), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 76.5,
    width: 305,
    height: 55,
    rx: 9.5,
    stroke: "#3F7CDB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5336_59870",
    x: 118,
    y: 70.5,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5336_59870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5336_59870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5336_59870",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.5 85.5) rotate(90) scale(159.187 308.134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5336_59870",
    x1: 165.5,
    y1: -62.5012,
    x2: 165.5,
    y2: 297.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474771,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5336_59870",
    x1: 151.413,
    y1: 106.998,
    x2: 165.498,
    y2: 88.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5336_59870",
    x1: 152.997,
    y1: 114.666,
    x2: 152.997,
    y2: 126.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5336_59870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 216,
    fill: "white",
    transform: "translate(62 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5336_59870"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 76,
    width: 306,
    height: 56,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5336_59870"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 85,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchAmlImg);
export default __webpack_public_path__ + "static/media/batch-aml-img.2fcb84afa8aebea02204f5ee1d8ec3cd.svg";
export { ForwardRef as ReactComponent };